import * as PIXI from "pixi.js";
import {Container} from "pixi.js";
import {app, clickSound, events, gameData} from "../../utils/pixiApp";
import {getDeviceMedia} from "../../utils/sizes";

const sizes = {
    web: {
        containerWidth: 234,
        containerHeight: 88,
        buttons: 42,
        betFontSize: 24,
        textFontSize: 18,
        lineHeight: '130%',
        margin: 34,
        padding: 16,
        betWidth: 70,
        betHeight: 56,
        textBetPos: {
            x: 35,
            y: 41
        }
    },
    mobile: {
        containerWidth: 151.6,
        containerHeight: 57,
        buttons: 32,
        betFontSize: 16,
        textFontSize: 12,
        margin: 22,
        padding: 10,
        betWidth: 47,
        betHeight: 42,
        textBetPos: {
            x: 23,
            y: 30
        }
    }
}

const buttons = {
    minus: {
        default: 'minusActive',
        hover: 'minusHover',
        disabled: 'minusDisabled'
    },
    plus: {
        default: 'plusActive',
        hover: 'pluHover',
        disabled: 'plusDisabled'
    }
}

const headerStyle = new PIXI.TextStyle({
    fontSize: 18,
    fontFamily: "Montserrat, sans-serif",
    fill: '#ffffff',
    fontWeight: 500,
})
const betStyle = new PIXI.TextStyle({
    fontSize: 24,
    textTransform: 'uppercase',
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 'bold',
    fill: '#ffffff',
    letterSpacing: .24,
    lineHeight: 21
})

const headerMobileStyle = new PIXI.TextStyle({
    fontSize: 12,
    fontFamily: "Montserrat, sans-serif",
    fill: '#ffffff',
    fontWeight: 500,
})
const betMobileStyle = new PIXI.TextStyle({
    fontSize: 16,
    textTransform: 'uppercase',
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 'bold',
    fill: '#ffffff',
    letterSpacing: .16,
    lineHeight: 24
})

export class Bet extends PIXI.Container {
    constructor(parentWidth, parentHeight) {
        super();
        this.media = getDeviceMedia(app.screen.width)
        const data = gameData.getGameData()
        this.bets = data.bets;
        this.activeBet = data.activeBet;

        this.position.set(parentWidth / 2, parentHeight / 2);

        this.pivot.set(sizes[this.media].containerWidth + sizes[this.media].margin / 2, sizes[this.media].containerHeight / 2)
        this.bg = new PIXI.Sprite(PIXI.Texture.from('bet'));
        this.bg.setSize(sizes[this.media].containerWidth, sizes[this.media].containerHeight)
        this.addChild(this.bg)


        this.startBetIdx = 0
        if(typeof data?.bets === 'object') {
            let calcIdx = -1
            data.bets.forEach((val, key) => {
                calcIdx += 1
                if(key === data.activeBet) {
                    this.startBetIdx = calcIdx
                }
            })
        }
        this.minus = new PIXI.Sprite(PIXI.Texture.from(this.startBetIdx > 0 ? buttons.minus.default : buttons.minus.disabled));
        this.minus.setSize(sizes[this.media].buttons)
        this.minus.position.set(sizes[this.media].padding, sizes[this.media].containerHeight / 2)
        this.minus.anchor.set(0,.5)
        this.addChild(this.minus)

        this.plus = new PIXI.Sprite(PIXI.Texture.from(buttons.plus.default));
        this.plus.setSize(sizes[this.media].buttons)
        this.plus.position.set(this.bg.width - sizes[this.media].padding - sizes[this.media].buttons, sizes[this.media].containerHeight / 2)
        this.plus.anchor.set(0,.5)
        this.addChild(this.plus)

        this.bet = new Container()
        this.bet.width = sizes[this.media].betWidth
        this.bet.height = sizes[this.media].betHeight
        this.bet.position.set(this.bg.width / 2 - (sizes[this.media].betWidth / 2),this.bg.height / 2 - sizes[this.media].betHeight / 2)
        this.textHeader = new PIXI.Text({ text: 'Ставка:', style: this.media === 'web' ? headerStyle : headerMobileStyle });
        this.textBet = new PIXI.Text({ text: String(this.activeBet).replace(".",","), style: this.media === 'web' ? betStyle : betMobileStyle });
        this.textBet.anchor.set(.5,.5)
        this.textBet.position.set(sizes[this.media].textBetPos.x, sizes[this.media].textBetPos.y)
        this.bet.addChild(this.textHeader,this.textBet)
        this.addChild(this.bet)

        this.plus.eventMode = 'static'
        this.minus.eventMode = this.startBetIdx > 0 ? 'static' : 'none'
        this.plus.cursor = 'pointer'
        this.minus.cursor = 'pointer'

        this.plus.on('pointerdown', () => this.onClick('top'))
        this.minus.on('pointerdown', () => this.onClick('bottom'))
        // this.plus.on('pointerover', () => this.onHover('top'))
        // this.minus.on('pointerover', () => this.onHover('bottom'))
        this.plus.on('pointerout', () => this.onOut('top'))
        this.minus.on('pointerout', () => this.onOut('bottom'))
        this.events = events

        this.events.onGameDataChange(this.setData.bind(this))
    }

    setSizes(width, height, media) {
        this.media = media
        this.position.set(width / 2, height / 2);
        this.pivot.set(sizes[media].containerWidth + sizes[media].margin / 2, sizes[media].containerHeight / 2)

        this.bg.setSize(sizes[this.media].containerWidth, sizes[this.media].containerHeight)

        this.minus.setSize(sizes[this.media].buttons)
        this.minus.position.set(sizes[this.media].padding, sizes[this.media].containerHeight / 2)

        this.plus.setSize(sizes[this.media].buttons)
        this.plus.position.set(this.bg.width - sizes[this.media].padding - sizes[this.media].buttons, sizes[this.media].containerHeight / 2)

        // this.bet.width = sizes[this.media].betWidth
        // this.bet.height = sizes[this.media].betHeight
        this.textHeader.style = this.media === 'web' ? headerStyle : headerMobileStyle
        this.textBet.style = this.media === 'web' ? betStyle : betMobileStyle
        this.textBet.position.set(sizes[this.media].textBetPos.x, sizes[this.media].textBetPos.y)
        this.bet.position.set(this.bg.width / 2 - (sizes[this.media].betWidth / 2),this.bg.height / 2 - sizes[this.media].betHeight / 2)
    }

    setData(eventArray) {
        if(eventArray === undefined) return
        if(eventArray.indexOf('activeBet') !== -1 || eventArray.indexOf('bets') !== -1) {
            const data = gameData.getGameData()
            this.bets = data.bets;
            this.activeBet = data.activeBet;
            this.textBet.text = String(this.activeBet).replace(".",",");
        }
    }

    setBet(bet) {
        events.emitBetChange(bet)
    }

    onClick(direction) {
        const betsKeysArr = [...this.bets.keys()]
        this.sound();
        if(direction === 'top') {
            if(betsKeysArr.indexOf(this.activeBet) + 1 === betsKeysArr.length - 1) {
                this.plus.eventMode = 'none'
                this.plus.texture = PIXI.Texture.from(buttons.plus.disabled)
            } if(this.minus.eventMode === 'none') {
                this.minus.eventMode = 'static'
                this.minus.texture = PIXI.Texture.from(buttons.minus.default)
            }
            this.setBet(betsKeysArr[betsKeysArr.indexOf(this.activeBet) + 1])
        } else {
            if(betsKeysArr.indexOf(this.activeBet) - 1 === 0) {
                this.minus.eventMode = 'none'
                this.minus.texture = PIXI.Texture.from(buttons.minus.disabled)
            }if(this.plus.eventMode === 'none') {
                this.plus.eventMode = 'static'
                this.plus.texture = PIXI.Texture.from(buttons.plus.default)
            }
            this.setBet(betsKeysArr[betsKeysArr.indexOf(this.activeBet) - 1])
        }
    }

    onHover(direction) {
        if(direction === 'top') {
            this.plus.texture = PIXI.Texture.from(buttons.plus.hover)
        } else {
            this.minus.texture = PIXI.Texture.from(buttons.minus.hover)
        }
    }

    onOut(direction) {
        if(direction === 'top') {
            this.plus.texture = PIXI.Texture.from(buttons.plus.default)
        } else {
            this.minus.texture = PIXI.Texture.from(buttons.minus.default)
        }
    }

    sound() {
        if(gameData.getGameData('sound')) {
            clickSound.play()
        }
    }
}